import ResourcesBreadcrumb from './ResourcesBreadcrumb';

export default ResourcesBreadcrumb;
